
import { Component, Prop, Vue } from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { mixins } from "vue-class-component";
import { VisitsMix } from "@/UI/mixins/Clients/VisitsMix";
import { NotesTableMix } from "@/UI/mixins/Clients/NotesTableMix";
import { SalonsMix } from "@/UI/mixins/SalonsMix";
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue";
import { FiltersData } from "@/entity/filters/extFilter";
import { SettingsUserMix } from "@/UI/mixins/Users/SettingsUserMix";
import { ClientsMix } from "@/UI/mixins/ClientsMix";
import { prefixObj } from "@/UI/lib/support";
import { getStudioId } from "@/UI/lib/state";
import { ProxyGetData } from "@/UI/components/Helpers/getData";
import { checkUserRole } from "@/router/Lib/helper";
import { UserStore } from "@/store/modules/User";
import { IWorkersListItem } from "@/entity/workers/workers.types";
import { VisitsStore } from "@/store/modules/Visits";

@Component({
  components: {
    PageTitle,
    FilterTableComponent
  },
  methods: {
    prefixObj
  },
  computed: {
    checkUserRole
  }
})
export default class WorkerNotes extends mixins(
  ProxyGetData,
  VisitsMix,
  NotesTableMix,
  SalonsMix,
  SettingsUserMix,
  ClientsMix
) {
  @Prop() readonly worker!: IWorkersListItem | null;

  filtersData = new FiltersData();

  loading = false;
  data: any[] = [];

  async handlePagination(pager: Record<any, any>): Promise<void> {
    this.table_load = true;
    //this.pager = pager
    this.AppPageParams.current = pager.current;
    this.AppPageParams.pageSize = pager.pageSize;
    this.AppPageParams.pageNum = pager.pageNum;

    const fetch = await this.fetchModules([
      {
        s: 'visits',
        p: {
          skip: pager.pageSize * (pager.current - 1),
          limit: pager.pageSize,
          filter: { salon_id: getStudioId(this), cosmetologists_id: this.worker?.id }
        }
      }
    ]);
    console.log("page", fetch)

    this.table_load = false;
  }

  sort(by: string, column: Record<any, any>): void {
    if (column.dataIndex === 'salon.name') {
      column.dataIndex = 'salon_id'
    }
    if (column.dataIndex === 'status') {
      column.dataIndex = 'status_id'
    }
    this.sortedData(by, column)
  }

  async created(): Promise<void> {
    try {
      this.AppPageParams.current = 1;
      let modules: any = [
        //{s: 'workers', p: {limit: -1, filter: {salon_id: getStudioId(this), 'status': 'all'}}},
        { s: 'user', p: { limit: -1, filter: { salon_id: getStudioId(this) } } },
        { s: 'visits', p: { limit: 10, filter: { salon_id: getStudioId(this), cosmetologists_id: this.worker?.id } } }
      ]
      await this.fetchModules(modules)
      if (VisitsStore.visits && VisitsStore.visits.total) {
        this.AppPageParams.total = VisitsStore.visits.total;
      } else {
        this.AppPageParams.total = this.visits?.total ?? 0;
      }
      //this.setFilters(this)

    } catch (e) {
      console.error(e)
    } finally {
      this.table_load = false
    }
  }
}
